import { render, staticRenderFns } from "./SocialMarketingImage.vue?vue&type=template&id=0120ea89&scoped=true&"
import script from "./SocialMarketingImage.vue?vue&type=script&lang=js&"
export * from "./SocialMarketingImage.vue?vue&type=script&lang=js&"
import style0 from "./SocialMarketingImage.vue?vue&type=style&index=0&id=0120ea89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0120ea89",
  null
  
)

export default component.exports